export const selectSearch = (state) => state.search.search;
export const selectPage = (state) => state.search.page;
export const selectData = (state) => state.search.data;
export const selectError = (state) => state.search.error;
export const selectLoading = (state) => state.search.loading;
